import {
  Code,
  Ellipsis,
  Scissors,
  Compass,
  createElement,
  FileDown,
  Globe,
  LocateFixed,
  MapPin,
  PanelRightClose,
  PanelRightOpen,
  Pencil,
  RotateCcw,
  RotateCw,
  Save,
  Share2,
  Trash2,
  type IconNode,
} from 'lucide';
import { ownValue } from '../shared/runtime-values.js';

const iconMap = {
  ellipsis: Ellipsis,
  scissors: Scissors,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  'trash-2': Trash2,
  code: Code,
  'share-2': Share2,
  globe: Globe,
  'map-pin': MapPin,
  'locate-fixed': LocateFixed,
  compass: Compass,
  pencil: Pencil,
  save: Save,
  'file-down': FileDown,
  'panel-right-close': PanelRightClose,
  'panel-right-open': PanelRightOpen,
} satisfies Record<string, IconNode>;

export function initIcons() {
  document.querySelectorAll('[data-lucide]').forEach((el) => {
    // SAFETY: The component contract supplies this value with the stated DOM type.
    const htmlEl = el as HTMLElement;
    const iconName = htmlEl.dataset.lucide;
    if (!iconName) return;
    const icon = ownValue(iconMap, iconName);
    if (!icon) {
      console.warn(`Unknown lucide icon: ${iconName}`);
      return;
    }

    const svg = createElement(icon);

    for (const attr of htmlEl.attributes) {
      if (attr.name !== 'data-lucide') {
        svg.setAttribute(attr.name, attr.value);
      }
    }

    htmlEl.replaceWith(svg);
  });
}
